module.exports = __webpack_public_path__ + "static/media/Pic-0341.ad7b492c.jpg";